<template>
  <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
    <div class="card-body p-15 p-sm-20 p-md-25">
      <div
        v-if="user.stock == 0"
        class="alert alert-danger alert-dismissible fs-md-15 fs-lg-16"
        role="alert"
      >
        Votre stock est désactivé ! Vous avez pouvez pas ajouter colis de stock
        <button
          type="button"
          class="btn-close shadow-none"
          data-bs-dismiss="alert"
          aria-label="Close"
        ></button>
      </div>

      <form
        class="row g-3"
        @submit.prevent="handleSubmit"
        :style="[
          user.stock == 0
            ? 'pointer-events: none; opacity: 0.6;'
            : 'opacity: 1;',
        ]"
      >
        <!-- Colis -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="colis"
            >Colis</label
          >
          <v-select
            class="custom-select-height"
            id="colis"
            label="text"
            v-model="OpenColi"
            :options="ColisList"
          />
        </div>

        <!-- Fragile -->
        <!-- <div class="col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="fragile"
            >Fragile</label
          >
          <v-select
            class="custom-select-height"
            id="fragile"
            label="text"
            v-model="fragile"
            :options="FragileColis"
          />
          <small v-if="fragile.value == 1 && FragileFees != null">
            <b
              >Frais pour colis fragile : {{ FragileFees.fees }}
              {{ FragileFees.devis }}</b
            >
          </small>
        </div> -->

        <!-- Radios Replace -->
        <div class="col-md-6 form-group mb-3">
          <b-form-radio
            v-model="ReplaceColis"
            :value="0"
            class="custom-control-success"
            size="md"
          >
            Colis Simple
          </b-form-radio>
        </div>

        <div class="col-md-6 form-group mb-3">
          <b-form-radio
            v-model="ReplaceColis"
            :value="1"
            class="custom-control-success"
            size="md"
          >
            Colis Change
            <span :style="[ReplaceColis == 1 ? { 'font-size': '12px' } : '']">
              <br />
              Le colis sera remplacé avec le colis :
            </span>
          </b-form-radio>
          <div v-if="ReplaceColis == 1">
            <input
              class="form-control"
              placeholder="Code de suivi"
              v-model="form.code_replace"
              @change="searchColis"
            />
            <small class="text-danger" v-if="existcolis"
              >Ce colis n'existe pas</small
            >
            <small class="text-danger" v-if="replacecolis"
              >Vous ne pouvez pas remplacer ce colis</small
            >
          </div>
        </div>

        <div class="col-12"><hr /></div>

        <!-- Code suivi -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="code"
            >Code de suivi</label
          >
          <input
            id="code"
            v-model="form.code"
            @change="verifiedCode"
            placeholder="Code de suivi"
            class="form-control"
          />
          <small class="text-danger" v-if="codeerror"
            >Ce code existe déjà</small
          >
        </div>

        <!-- Destinataire -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="dest"
            >Destinataire</label
          >
          <input
            id="dest"
            v-model="form.receiver"
            placeholder="Destinataire"
            class="form-control"
          />
        </div>

        <!-- Téléphone -->
        <div class="col-md-4 form-group mb-3">
          <label class="form-label fw-medium text-black" for="phone"
            >Numéro de téléphone *</label
          >

          <input
            id="phone"
            v-model="form.phone"
            type="text"
            inputmode="numeric"
            pattern="0[0-9]{9}"
            maxlength="10"
            @change="blackList(form.phone)"
            @input="validatePhone()"
            placeholder="0XXXXXXXXX"
            class="form-control"
            required
            @keypress="if (isNaN(Number($event.key))) $event.preventDefault();"
          />
          <small class="text-danger" v-if="phoneError">
            Numéro invalide (doit commencer par 0 et contenir 10 chiffres)
          </small>
          <template v-if="!phoneError && error_blacklst.msg">
            <small class="text-danger" v-if="error_blacklst.msg == 'exist'">
              Ce numéro est dans la black liste (
              {{ error_blacklst.count }} fois)
            </small>
            <small class="text-success" v-if="error_blacklst.msg == 'not exist'"
              >Ce numéro est sûr</small
            >
          </template>
        </div>

        <!-- Ville -->
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="city"
            >Ville</label
          >
          <v-select
            class="custom-select-height"
            id="city"
            required
            label="name"
            v-model="city"
            :options="citiesList"
            placeholder="Ville"
            @update:modelValue="onCityChange"
          />
        </div>

        <!-- Quartier 
        <div class="col-12 form-group mb-3">
          <label class="form-label fw-medium text-black" for="quartier"
            >Quartier</label
          >
          <v-select
            class="custom-select-height"
            id="quartier"
            label="name"
            :disabled="!city.id"
            v-model="quartier"
            :options="quartierList"
            placeholder="Quartier"
          />
        </div>-->

        <!-- Adresse -->
        <div class="col-12 col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="adresse"
            >Adresse</label
          >

          <textarea
            id="adresse"
            rows="2"
            maxlength="90"
            v-model="form.address"
            placeholder="Adresse"
            class="form-control"
          ></textarea>
        </div>

        <!-- Commentaire -->
        <div class="col-12 col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="comment"
            >Commentaire</label
          >

          <textarea
            id="comment"
            v-model="form.note"
            rows="2"
            maxlength="55"
            placeholder="Commentaire"
            class="form-control"
          ></textarea>
        </div>

        <!-- Prix -->
        <div class="col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="price"
            >Prix</label
          >

          <input
            id="price"
            v-model="form.price"
            type="number"
            min="0"
            placeholder="Prix"
            class="form-control"
            required
          />
        </div>

        <div class="col-md-6 form-group mb-3">
          <label class="form-label fw-medium text-black" for="product_type"
            >Nature du produit</label
          >

          <input
            id="product_type"
            v-model="form.product_type"
            type="text"
            placeholder="Nature du produit"
            class="form-control"
          />
        </div>

        <div class="row mb-3">
          <div class="col-12">
            <strong>Frais de livraison (Ramassage {{ city.name }}) :</strong>
            {{ fees_livred }}<br /><br />

            <strong
              >Frais de livraison (Ramassage Hors {{ city.name }}) :</strong
            >
            {{ fees_livred_hors }}<br />
          </div>
        </div>

        <!-- Submit -->
        <div
          class="col-md-12 d-flex align-items-center justify-content-between mt-20"
        >
          <button
            type="submit"
            class="btn btn-success px-4 py-2"
            :disabled="codeerror == true"
          >
            Enregistrer
            <span
              v-if="loading"
              class="spinner-border spinner-border-sm ms-2"
            ></span>
          </button>

          <button v-if="exist" type="button" class="btn btn-info px-4 py-2">
            Modifier Colis
          </button>
        </div>
      </form>
    </div>
  </div>

  <template v-if="exist">
    <div class="row">
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
          <div class="card-header">
            <h5 class="mb-20 mt-3">Produits En Stock</h5>
          </div>
          <div class="row">
            <div class="col-12 m-2">
              <label>Voir</label>
              <v-select
                :options="[10, 25]"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entité</label>
            </div>
          </div>
          <vue-good-table :columns="columns" :rows="Products" responsive>
            <template #emptystate></template>
            <template #table-row="props">
              <span
                v-if="props.column.field === 'product_pic'"
                class="text-nowrap"
              >
                <img
                v-if="props.row.product_pic"
                :src="props.row.product_pic"
                class="rounded-circle me-15"
                style="width: 30px; height: 30px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 30px; height: 30px; object-fit: cover"
              />
              </span>

              <span
                v-else-if="props.column.field === 'product_name'"
                class="text-nowrap"
              >
                <b>{{ props.row.product_name }}</b>
              </span>

              <span
                v-else-if="props.column.field === 'var_name'"
                class="text-nowrap"
              >
                <b>{{ props.row.var_name }}</b> :
                {{ props.row.qty }}
              </span>

              <template v-else-if="props.column.field === 'action'">
                <div class="action-cell">
                  <!-- Quantity input -->
                  <div class="qty-wrapper">
                    <input
                      type="number"
                      class="form-control qty-input"
                      v-model.number="props.row.value"
                      min="1"
                      :max="props.row.qty"
                    />
                    <span class="qty-max">/ {{ props.row.qty }}</span>
                  </div>

                  <!-- Save button -->
                  <button
                    class="btn btn-save"
                    @click="GetQnty(props.row)"
                    title="Enregistrer"
                  >
                    <i class="flaticon-diskette"></i>
                  </button>
                </div>
              </template>


              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
      <div class="col-md-6">
        <div class="card mb-25 border-0 rounded-0 bg-white letter-spacing">
          <div class="card-header">
            <h5 class="mb-20 mt-3">Liste des Produits du colis</h5>
          </div>
          <div class="row">
            <div class="col-12 m-2">
              <label>Voir</label>
              <v-select
                :options="[10, 25]"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
              />
              <label>entité</label>
            </div>
          </div>
          <vue-good-table :columns="columns2" :rows="ProductsColis" responsive>
            <template #emptystate></template>
            <template #table-row="props">
              <span
                v-if="props.column.field === 'product_pic'"
                class="text-nowrap"
              >
                <img
                v-if="props.row.product_pic"
                :src="props.row.product_pic"
                class="rounded-circle me-15"
                style="width: 30px; height: 30px; object-fit: cover"
              />
              <img
                v-else
                :src="require('@/assets/images/NoImage.png')"
                class="rounded-circle me-15"
                style="width: 30px; height: 30px; object-fit: cover"
              />
              </span>

              <span
                v-else-if="props.column.field === 'product_name'"
                class="text-nowrap"
              >
                <b>{{ props.row.product_name }}</b>
              </span>

              <span
                v-else-if="props.column.field === 'var_name'"
                class="text-nowrap"
              >
                <b>{{ props.row.variant_name }}</b> |
                {{ props.row.qnty }} unités
              </span>

              <template v-else-if="props.column.field === 'action'">
                <div style="display: flex; align-items: center; width: 100%">
                  <input
                    class="form-control"
                    v-model="props.row.value"
                    type="number"
                    min="1"
                    :max="props.row.qnty"
                    style="width: 70%; margin-right: 8px"
                  />
                  <button
                    class="border-0 d-inline-block p-0 rounded-circle text-center transition"
                    @click="RemoveQnty(props.row)"
                    style="white-space: nowrap"
                  >
                    <i class="flaticon-delete"></i>
                  </button>
                </div>
              </template>

              <span v-else>
                {{ props.formattedRow[props.column.field] }}
              </span>
            </template>
          </vue-good-table>
        </div>
      </div>
    </div>
    <template v-if="ProductsColis.length != 0">
      <div class="col-12">
        <hr />
      </div>
      <div class="col-12 mb-40">
        <button class="btn btn-success" @click="SaveColiStock">
          Prêt pour la préparation
        </button>
      </div>
    </template>
  </template>
</template>

<script lang="ts">
import { useAppToast } from "@/composables/useAppToast";
import { useSanitize } from "@/composables/useSanitize";
import api from "@/utils/axios";
import moment from "moment";
import Swal from "sweetalert2";
import { onMounted, reactive, ref } from "vue";
import { useAuthStore } from "@/stores/auth";
import "@trevoreyre/autocomplete-vue/dist/style.css";
import router from "@/router";

export default {
  name: "NewColis",
  components: {},
  setup: () => {
    const { showToast } = useAppToast();
    const { sanitizeText } = useSanitize();

    const auth = useAuthStore();
    const user = auth.user;

    const colisOptions = ref([]);

    const citiesList = ref([]);
    const quartierList = ref([]);

    const loading = ref(false);

    const customer = ref<{
      id?: number;
      name?: string;
      phone?: string;
      delivered_price?: string;
      refused_price?: string;
      returned_price?: string;
    }>({});
    const city = ref<any>({});
    const agency = ref<{ id?: number; name?: string }>({});
    const quartier = ref({ id: 0, name: "" });

    const ColisList = [
      { value: 1, text: "Ouvrir le colis" },
      { value: 0, text: "Ne pas ouvrir le colis" },
    ];

    const OpenColi = ref({ value: 0, text: "Ne pas ouvrir le colis" });
    const FragileColis = [
      { value: 1, text: "Oui" },
      { value: 0, text: "Non" },
    ];
    const fragile = ref({ value: 0, text: "Non" });
    const error_blacklst = ref({ msg: "", count: "" });
    const statut = ref({ id: 0, name: null, code: null });

    const ReplaceColis = ref(0);
    const RplColis = ref("");
    const existcolis = ref(false);
    const replacecolis = ref(false);
    const FragileFees = ref(null);
    const codeerror = ref(false);
    const phoneError = ref(false);

    const fl = ref("");
    const fr = ref("");
    const frf = ref("");

    const fees_livred = ref("");
    const fees_livred_hors = ref("");

    const fees_returned = ref("");
    const fees_refused = ref("");

    const exist = ref(false);
    const value = ref(1);
    const columns = ref([
      {
        label: "",
        field: "product_pic",
      },
      {
        label: "Nom du produit",
        field: "product_name",
      },
      {
        label: "Agence",
        field: "agency_name",
      },
      {
        label: "Quantité",
        field: "var_name",
      },
      {
        label: "Actions",
        field: "action",
        width: "180px",
      },
    ]);
    const columns2 = ref([
      {
        label: "",
        field: "product_pic",
      },
      {
        label: "Nom du produit",
        field: "product_name",
      },
      {
        label: "Agence",
        field: "stock_agency_name",
      },
      {
        label: "Quantité",
        field: "var_name",
      },
      {
        label: "Actions",
        field: "action",
      },
    ]);
    const Products = ref([]);
    const ProductsColis = ref([]);

    const form = reactive({
      id: 0,
      code: "",
      can_open: 1,
      fragile: 0,
      replace: 0,
      code_replace: "",
      receiver: "",
      phone: "",
      address: "",
      note: "",
      price: "",
      product_type: "",
    });

    // 🔹 Fonction pour reset le form
    function resetForm() {
      form.id = 0;
      form.code = "";
      form.can_open = 1;
      form.fragile = 0;
      form.replace = 0;
      form.code_replace = "";
      form.receiver = "";
      form.phone = "";
      form.address = "";
      form.note = "";
      form.price = "";
    }

    onMounted(async () => {
      try {
        const response = await api.get(`/api/auth/client/citiesFees`);
        if (response && response.data) {
          citiesList.value = response.data;
        }
      } catch (error) {
        console.error("Error fetching user data:", error);
      }
    });

    async function onInputChange(text) {
      if (!text) {
        return;
      }

      try {
        const res = await api.get(`/api/auth/SearchColis`, {
          params: { searchcolis: text },
        });

        if (res.data?.msg === "success") {
          colisOptions.value = res.data.data;
        }
      } catch (error) {
        console.error("Erreur lors de la recherche des colis :", error);
      }
    }

    async function getQuartier(city) {
      const res = await api.get(
        `/api/auth/client/QuartierList?city=${city.id}`
      );
      quartierList.value = res.data;
    }

    const showFees = (city: {
      delivered_fees?: string;
      delivered_same_city_fees?: string;
    }) => {
      fees_livred.value = city.delivered_same_city_fees ?? "";
      // If you want to use fees_livred_hors, declare it as a ref above and assign its value here:
      fees_livred_hors.value = city.delivered_fees ?? "";
    };

    async function getFragileFees() {
      if (fragile.value.value == 1) {
        const res = await api.get(
          `/api/auth/client/FragileFeesCust?cust=${customer.value.id}`
        );

        if (res.data.msg == "success") {
          FragileFees.value = res.data.data;
        }
      }
    }

    // async function getSuggestionValue(suggestion) {
    //   suggestion.item.code = suggestion.item.code + "_2";

    //   customer.value = {
    //     id: suggestion.item.customer,
    //     name: suggestion.item.customer_name,
    //   };

    //   city.value = {
    //     id: suggestion.item.city_id,
    //     name: suggestion.item.city_name,
    //   };

    //   quartier.value = {
    //     id: suggestion.item.quartier_id,
    //     name: suggestion.item.quartier_name ?? "",
    //   };

    //   OpenColi.value = {
    //     value: suggestion.item.can_open,
    //     text: suggestion.item.can_open
    //       ? "Ouvrir le colis"
    //       : "Ne pas ouvrir le colis",
    //   };

    //   fragile.value = {
    //     value: suggestion.item.fragile,
    //     text: suggestion.item.fragile ? "Oui" : "Non",
    //   };

    //   if (suggestion.item.replace == 1) {
    //     ReplaceColis.value = 1;
    //   } else if (suggestion.item.partial == 1) {
    //     ReplaceColis.value = 2;
    //   } else {
    //     ReplaceColis.value = 0;
    //   }

    //   resetForm();
    //   Object.assign(form, suggestion.item); // copie toutes les propriétés
    //   form.phone = oldPhone(suggestion.item.phone); // formatage du téléphone

    //   try {
    //     const res = await api.get(
    //       `/api/auth/GetFeesLivred?city=${city.value.id}&customer=${customer.value.id}`
    //     );

    //     if (res.data) {
    //       fl.value = res.data.liv_fees;
    //       fr.value = res.data.refus_fees;
    //       frf.value = res.data.return_fees;
    //     }
    //   } catch (error) {
    //     console.error("Erreur lors de la récupération des frais :", error);
    //   }
    // }

    function oldPhone(val) {
      if (val && val !== "" && val != null) {
        let phone = "";
        if (val.substring(0, 4) === "+212" && val.length === 13) {
          return `0${val.slice(4)}`;
        }
        if (val.substring(0, 3) === "212" && val.length === 12) {
          phone = `0${val.slice(2)}`;
          return phone;
        }
        if (val.substring(0, 1) === "0" && val.length === 10) {
          return val;
        }
        if (
          val.substring(0, 1) === "6" ||
          (val.substring(0, 1) === "7" && val.length === 9)
        ) {
          // phone = "+212" + val;
          return val;
        }
        if (val.substring(0, 5) === "00212" && val.length === 14) {
          return `0${val.substring(0, 5)}`;
        }
      } else {
        return val;
      }
    }

    async function search(input) {
      if (input.length < 2) return [];

      try {
        const res = await api.get(`/api/auth/SearchColis?searchcolis=${input}`);
        return res.data.data ?? [];
      } catch (error) {
        console.error("Erreur lors de la recherche:", error);
        return [];
      }
    }

    async function handleSelect(suggestion) {
      console.log("sufes", suggestion);
      // Adjust code
      suggestion.item.code = suggestion.item.code + "_2";

      customer.value = {
        id: suggestion.item.customer,
        name: suggestion.item.customer_name,
      };

      city.value = {
        id: suggestion.item.city_id,
        name: suggestion.item.city_name,
      };

      quartier.value = {
        id: suggestion.item.quartier_id,
        name: suggestion.item.quartier_name ?? "",
      };

      OpenColi.value = {
        value: suggestion.item.can_open,
        text: suggestion.item.can_open
          ? "Ouvrir le colis"
          : "Ne pas ouvrir le colis",
      };

      fragile.value = {
        value: suggestion.item.fragile,
        text: suggestion.item.fragile ? "Oui" : "Non",
      };

      if (suggestion.item.replace == 1) {
        ReplaceColis.value = 1;
      } else if (suggestion.item.partial == 1) {
        ReplaceColis.value = 2;
      } else {
        ReplaceColis.value = 0;
      }

      resetForm();
      Object.assign(form, suggestion.item);
      form.phone = oldPhone(suggestion.item.phone);

      try {
        const res = await api.get(
          `/api/auth/GetFeesLivred?city=${city.value.id}&customer=${customer.value.id}`
        );

        if (res.data) {
          fl.value = res.data.liv_fees;
          fr.value = res.data.refus_fees;
          frf.value = res.data.return_fees;
        }
      } catch (error) {
        console.error("Erreur lors de la récupération des frais :", error);
      }
    }

    function validatePhone() {
      const moroccanPhone = /^0[0-9]{9}$/;
      phoneError.value = !!form.phone && !moroccanPhone.test(form.phone);
    }

    async function searchColis() {
      existcolis.value = false;
      replacecolis.value = false;

      try {
        const data = new FormData();
        data.append("codesuivi", sanitizeText(form.code_replace));

        const res = await api.post(`/api/auth/client/ColisExist`, data);

        if (res.data === "not exist") {
          existcolis.value = true;
        } else if (res.data === "exist") {
          existcolis.value = false;
        } else if (res.data === "error status") {
          replacecolis.value = true;
        }
      } catch (error) {
        console.error("Erreur lors de la vérification du colis :", error);
      }
    }

    async function blackList(phone) {
      if (this.phone && this.phone.length == 10) {
        try {
          // if (JSON.parse(localStorage.getItem('PermsCstmr')).black_list == 1) {

          // reset values
          error_blacklst.value = { msg: "", count: "" };

          const res = await api.post(
            `/api/auth/client/blackList?phone=${phone}`
          );

          error_blacklst.value.msg = res.data.msg;
          error_blacklst.value.count = res.data.count;
        } catch (error) {
          console.error(
            "Erreur lors de la vérification de la blacklist :",
            error
          );
        }
      }
    }

    async function checkWhite(phone) {
      try {
        // reset values
        error_blacklst.value = { msg: "", count: "" };

        const res = await api.post(`/api/auth/client/whiteList?phone=${phone}`);

        error_blacklst.value.msg = res.data.msg;
        error_blacklst.value.count = res.data.count;
      } catch (error) {
        console.error(
          "Erreur lors de la vérification de la whiteList :",
          error
        );
      }
    }

    async function verifiedCode() {
      codeerror.value = false;

      if (form.code) {
        try {
          const data = new FormData();
          data.append("codesuivi", sanitizeText(form.code));

          const res = await api.post(
            `/api/auth/client/search_code_colis`,
            data
          );

          if (res.data === "exist") {
            codeerror.value = true;
            showToast("Un colis avec ce code existe déjà", "error");
          } else {
            codeerror.value = false;
          }
        } catch (error) {
          console.error(
            "Erreur lors de la vérification du code colis :",
            error
          );
        }
      }
    }

    function onCityChange(selectedCity) {
      city.value = selectedCity; // update v-model (optional, Vue does this automatically)
      showFees(selectedCity);
      // getQuartier(selectedCity);
    }

    // -------- Helper Functions --------
    const validateForm = () => {
      validatePhone();
      if (!form.receiver || !form.phone || !form.address) return false;
      if (phoneError.value) return false;
      if (form.price === '' || form.price === null || form.price === undefined) return false;
      if (ReplaceColis.value === 1 && (!form.code_replace || existcolis.value || replacecolis.value))
        return false;
      return true;
    };

    const buildFormData = () => {
      const data = new FormData();
      data.append("code", sanitizeText(form.code));
      data.append("adress", sanitizeText(form.address));
      data.append("note", sanitizeText(form.note));
      data.append("dest", sanitizeText(form.receiver));
      data.append("phone", sanitizeText(form.phone));
      data.append("city_name", sanitizeText(city.value.name));
      data.append("city_id", String(city.value.id));
      data.append("quartier_id", String(quartier.value.id) || null);
      data.append("price", form.price);
      data.append("fragile", String(fragile.value.value));
      data.append("can_open", String(OpenColi.value.value));
      data.append("replace", String(ReplaceColis.value));
      data.append("fees_livred", city.value.delivered_same_city_fees);
      data.append("fees_livred_hors", city.value.delivered_fees);
      data.append("retourned_fees", city.value.retourned_fees);
      data.append("refused_fees", city.value.refused_fees);
      data.append("prod_nat", sanitizeText(form.product_type));
      return data;
    };

    // Get products in the parcel
    async function getColiProduct() {
      try {
        const res = await api.get(
          `/api/auth/client/ProductColis?colis_id=${Parcel.value.id}`
        );
        ProductsColis.value = res.data;
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des produits du colis :",
          error
        );
      }
    }

    // Get products from inventory
    async function storeProducts() {
      try {
        const res = await api.get(`/api/auth/client/InventoryProduct`);
        Products.value = res.data;
      } catch (error) {
        console.error(
          "Erreur lors de la récupération des produits d'inventaire :",
          error
        );
      }
    }
    const Parcel = ref<any>({});

    // -------- Submit Function --------
    const handleSubmit = async () => {
      if (!validateForm()) {
        showToast("Merci de remplir tous les champs correctement", "error");
        return;
      }

      const data = buildFormData();

      loading.value = true;
      try {
        const res = await api.post("/api/auth/client/AddColisInventory", data);

        switch (res.data.message) {
          case "success":
            // Assign parcel data if needed (define a ref if you want to keep it)
            Parcel.value = res.data.parcel;
            await storeProducts();
            exist.value = true;
            showToast("Les données sont bien sauvegardées", "success");

            break;
          case "code exist":
            showToast("Un colis avec ce code existe déjà", "error");
            break;
          case "no customer":
            showToast("Ce client est supprimé ou désactivé", "error");
            break;
          default:
            showToast("Erreur lors de l'envoi", "error");
        }
      } catch (error) {
        console.error(error);
        showToast("Une erreur est survenue", "error");
      } finally {
        loading.value = false;
      }
    };

    // Add quantity of product to parcel
    async function GetQnty(row) {
      try {
        const data = new FormData();
        data.append("colis_id", String(Parcel.value.id));
        data.append("cstmr_id", row.customer);
        data.append("cstmr_name", row.customer_name);
        data.append("qnty", row.value);
        data.append("agency_var", row.agency);
        data.append("agency_var_name", row.agency_name);
        data.append("variantId", row.id);

        const res = await api.post("/api/auth/client/AddVariantParcel", data);

        if (res.data.message === "success") {
          await storeProducts();
          await getColiProduct();
          showToast("Les données sont bien sauvegardés", "success");
        } else if (res.data.message === "erro agency") {
          showToast("Vous pouvez pas ajouter ce produits, Pas dans la même agence de reception !", "error");
        } else{
          showToast(res.data.message ?? "Un erreur est survenue", "error");
        }
      } catch (error) {
        showToast("Une erreur est survenue", "error");
      }
    }

    // Remove quantity of product from parcel
    async function RemoveQnty(row) {
      try {
        const data = new FormData();
        data.append("colis_id", String(Parcel.value.id));
        data.append("cstmr_id", String(row.customer_id));
        data.append("cstmr_name", String(row.customer_name));
        data.append("qnty", String(row.value));
        data.append("agency_var", String(row.agency));
        data.append("agency_var_name", String(row.agency_name));
        data.append("content_id", String(row.id));
        data.append("inventory_id", String(row.inventory_id));

        const res = await api.post(
          "/api/auth/client/RemoveVariantParcel",
          data
        );

        if (res.data.message === "success") {
          await storeProducts();
          await getColiProduct();
          showToast("Les données sont bien sauvegardés", "success");
        }
      } catch (error) {
        showToast("Une erreur est survenue", "error");
      }
    }

    // Save parcel stock
    async function SaveColiStock() {
      try {
        const data = new FormData();
        data.append("colis_id", String(Parcel.value.id));

        const res = await api.post("/api/auth/client/SaveColiStock", data);

        if (res.data.message === "success") {
          await storeProducts();
          showToast("Les données sont bien sauvegardés", "success");
          router.push("/colis-stock-list");
        }
      } catch (error) {
        showToast("Une erreur est survenue", "error");
      }
    }

    return {
      auth,
      colisOptions,
      loading,
      onInputChange,
      form,
      search,
      handleSelect,

      OpenColi,
      ColisList,
      FragileColis,
      fragile,
      ReplaceColis,
      replacecolis,
      RplColis,
      existcolis,
      FragileFees,
      searchColis,
      quartier,
      city,
      agency,
      error_blacklst,
      fees_livred,
      fees_returned,
      fees_refused,

      fl,
      fr,
      frf,
      statut,
      codeerror,
      phoneError,
      validatePhone,

      customer,
      citiesList,
      quartierList,

      getQuartier,
      getFragileFees,
      showFees,
      blackList,
      verifiedCode,
      onCityChange,

      handleSubmit,
      fees_livred_hors,
      exist,
      columns,
      columns2,
      ProductsColis,
      Products,
      user,
      GetQnty,
      RemoveQnty,
      SaveColiStock,
    };
  },
};
</script>
<style scoped>
.action-cell {
  display: flex;
  align-items: center;
  gap: 8px;
}

.qty-wrapper {
  display: flex;
  align-items: center;
  background: #f8f9fa;
  border-radius: 8px;
  padding: 2px 6px;
}

.qty-input {
  width: 60px;
  border: none;
  background: transparent;
  text-align: center;
  font-weight: 600;
}

.qty-input:focus {
  outline: none;
  box-shadow: none;
}

.qty-max {
  font-size: 12px;
  color: #6c757d;
  margin-left: 4px;
}

.btn-save {
  width: 30px;
  height: 35px;
  /* border-radius: 50%; */
  border: none;
  background: #0d6efd;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;
}

.btn-save:hover {
  background: #0b5ed7;
  transform: scale(1.05);
}

.btn-save:active {
  transform: scale(0.95);
}

</style>